// Languages supported for per-location description translations.
// English (`en`) is the canonical fallback and must always be filled in.
//
// Adding a language here requires:
//   - Updating `availableLanguages` in piffl-server (src/common/languages.ts) and adding the field to
//     LocationTranslations / LocationTranslationsInput in the GraphQL schema (src/features/location/type-defs.ts).
//   - Re-running GraphQL codegen here so the GQL_LocationTranslationsInput type gains the field.

export const SUPPORTED_LOCATION_TRANSLATION_LANGUAGES = ['en', 'sv', 'no', 'da'] as const

export type SupportedLocationTranslationLanguage = (typeof SUPPORTED_LOCATION_TRANSLATION_LANGUAGES)[number]

export const LOCATION_TRANSLATION_LANGUAGE_LABELS: Record<SupportedLocationTranslationLanguage, string> = {
  en: 'English',
  sv: 'Swedish',
  no: 'Norwegian',
  da: 'Danish',
}

export const CANONICAL_FALLBACK_LANGUAGE: SupportedLocationTranslationLanguage = 'en'

// The non-canonical languages are the ones the form's Translations section asks for explicitly.
// English (the canonical fallback) is captured via the top-level Description field and copied
// into translations.en automatically on save, so it isn't part of this list.
export type NonCanonicalLocationTranslationLanguage = Exclude<SupportedLocationTranslationLanguage, 'en'>

export const NON_CANONICAL_LOCATION_TRANSLATION_LANGUAGES: ReadonlyArray<NonCanonicalLocationTranslationLanguage> =
  SUPPORTED_LOCATION_TRANSLATION_LANGUAGES.filter((lang): lang is NonCanonicalLocationTranslationLanguage => lang !== CANONICAL_FALLBACK_LANGUAGE)
